/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ToKoreaWarehouseVo
 */
export interface ToKoreaWarehouseVo {
    /**
     * 预计到达时间 yyyy-MM-dd HH:mm:ss
     * @type {string}
     * @memberof ToKoreaWarehouseVo
     */
    arrivedTime?: string;
    /**
     * 总箱数
     * @type {number}
     * @memberof ToKoreaWarehouseVo
     */
    boxNumber?: number;
    /**
     * 车牌号
     * @type {string}
     * @memberof ToKoreaWarehouseVo
     */
    vehicleInformation?: string;
    /**
     * 司机联系方式
     * @type {string}
     * @memberof ToKoreaWarehouseVo
     */
    driverTelephone?: string;
    /**
     * 托盘数量
     * @type {number}
     * @memberof ToKoreaWarehouseVo
     */
    palletNumber?: number;
    /**
     * 韩国国内运输方式id
     * @type {number}
     * @memberof ToKoreaWarehouseVo
     */
    krLocalTransportMethodId?: number;
}

/**
 * Check if a given object implements the ToKoreaWarehouseVo interface.
 */
export function instanceOfToKoreaWarehouseVo(value: object): value is ToKoreaWarehouseVo {
    return true;
}

export function ToKoreaWarehouseVoFromJSON(json: any): ToKoreaWarehouseVo {
    return ToKoreaWarehouseVoFromJSONTyped(json, false);
}

export function ToKoreaWarehouseVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToKoreaWarehouseVo {
    if (json == null) {
        return json;
    }
    return {
        
        'arrivedTime': json['arrivedTime'] == null ? undefined : json['arrivedTime'],
        'boxNumber': json['boxNumber'] == null ? undefined : json['boxNumber'],
        'vehicleInformation': json['vehicleInformation'] == null ? undefined : json['vehicleInformation'],
        'driverTelephone': json['driverTelephone'] == null ? undefined : json['driverTelephone'],
        'palletNumber': json['palletNumber'] == null ? undefined : json['palletNumber'],
        'krLocalTransportMethodId': json['krLocalTransportMethodId'] == null ? undefined : json['krLocalTransportMethodId'],
    };
}

export function ToKoreaWarehouseVoToJSON(json: any): ToKoreaWarehouseVo {
    return ToKoreaWarehouseVoToJSONTyped(json, false);
}

export function ToKoreaWarehouseVoToJSONTyped(value?: ToKoreaWarehouseVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'arrivedTime': value['arrivedTime'],
        'boxNumber': value['boxNumber'],
        'vehicleInformation': value['vehicleInformation'],
        'driverTelephone': value['driverTelephone'],
        'palletNumber': value['palletNumber'],
        'krLocalTransportMethodId': value['krLocalTransportMethodId'],
    };
}

